<div class="absolute z-[10000] bottom-10 left-10 flex flex-col gap-4 justify-start items-start bg-transparent">
  @for (alert of alerts(); track $index) {
    <div
      class="relative p-5 flex-shrink-0 gap-2 flex flex-col justify-center items-center bg-white rounded-md drop-shadow-md"
      [@slideInOutAnimation]="alert.animationState()"
      (@slideInOutAnimation.done)="animationHandler(alert)"
    >
      <div class="flex gap-2 justify-center items-center">
        <mat-icon class="text-{{ themes[alert.theme()].color }}">
          {{ themes[alert.theme()].icon }}
        </mat-icon>
        <span class="text-fc-text">{{ alert.message() }}</span>
      </div>
    </div>
  }
</div>
